export const searchAlertDescriptions = (query, alertDescriptions) => {
  return _.filter(alertDescriptions, (alertDescription) => {
    const translatedCode = alertDescription.code.toUpperCase().replace(/\.| /g, '')
    const translatedQuery = translate(query)

    if (translatedCode.includes(translatedQuery)) { return true }

    const regEx = new RegExp(query, 'i')

    if (_.any(alertDescription.tags, (tag) => tag.match(regEx))) { return true }
    if (alertDescription.description.match(regEx)) { return true }
    if (alertDescription.severity.match(regEx)) { return true }
    if (alertDescription.draft && 'draft'.match(regEx)) { return true }

    return _.any(['problems', 'possibleCauses', 'additionalInfo'], (attribute) => {
      const descriptions = alertDescription[attribute]

      return _.any((descriptions || []), (description) => {
        if (description.description.match(regEx)) { return true }

        return _.any((description.details || []), (detail) => {
          return detail.match(regEx)
        })
      })
    })
  })
}

export const searchConsolidatedEventsDescriptions = (query, events) => {
  return _.filter(events, (event) => {
    const translatedQuery = translate(query)

    const regEx = new RegExp(query, 'i')
    const effectAndCauseAlerts = event.effectAlerts.concat(event.causeAlerts)

    if (event.name.match(regEx)) { return true }
    if (event.id.match(regEx)) { return true }

    if (_.any(effectAndCauseAlerts, (code) => translate(code).includes(translatedQuery))) {
      return true
    }

    return _.any(event.possibleCauses, (description) => {
      if (description.description.match(regEx)) { return true }

      return _.any((description.details || []), (detail) => {
        return detail.match(regEx)
      })
    })
  })
}

const translate = (query) => {
  return query && query.toUpperCase().replace(/[^a-zA-Z0-9]/g, '').replace('ERR', 'CL2').replace('SDA', 'NDA')
}
